var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C9.75 0 12 4.125 12 4.125C12 4.125 9.75 8.25 6 8.25C2.25 8.25 0 4.125 0 4.125C0 4.125 2.25 0 6 0ZM6 0.75C3.36 0.75 1.4985 3.18825 0.88125 4.125C1.49775 5.061 3.35925 7.5 6 7.5C8.64 7.5 10.5015 5.06175 11.1187 4.125C10.5022 3.189 8.64075 0.75 6 0.75ZM6 1.5C6.69619 1.5 7.36387 1.77656 7.85616 2.26884C8.34844 2.76113 8.625 3.42881 8.625 4.125C8.625 4.82119 8.34844 5.48887 7.85616 5.98116C7.36387 6.47344 6.69619 6.75 6 6.75C5.30381 6.75 4.63613 6.47344 4.14384 5.98116C3.65156 5.48887 3.375 4.82119 3.375 4.125C3.375 3.42881 3.65156 2.76113 4.14384 2.26884C4.63613 1.77656 5.30381 1.5 6 1.5ZM6 2.25C5.5029 2.25059 5.02633 2.44832 4.67483 2.79983C4.32332 3.15133 4.12559 3.6279 4.125 4.125C4.125 5.1585 4.96575 6 6 6C7.03425 6 7.875 5.1585 7.875 4.125C7.875 3.0915 7.03425 2.25 6 2.25Z",
    fill: "#262F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.968e2c5957a4f2c6cd6ab9ad5ff066f1.svg";
export { ForwardRef as ReactComponent };